<template>
  <div class="game-tr-text-block-with-input-impr" :style="getStyle(startGameConfig)">
    <div
      v-for="(image, index) in imageData"
      :key="'image_' + index"
      class="main-image-container"
      :style="getImageStyle(image)"
    ></div>
    <tr-static-text
      :static-text="item"
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
    >
    </tr-static-text>

    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    ></tr-box>
    <div
      class="text-container-multiline"
      :style="getTextStyle(obj)"
      v-for="(obj, mainIndex) in textItem"
      :key="'main-index' + mainIndex"
    >
      <!-- <span v-katex="'\\frac{a_i}{1+x}'"></span> -->
      <div class="text-container" v-for="(elem, index) in obj.items" :key="index">
        <component :is="dynComponent(mainIndex, index)" v-bind="$props"></component>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * align in item element
 * @type {String} align - text-align (center|left|right)
 */
import _ from 'lodash';
import Vue from 'vue';
import * as utils from '../../Utils/inputUtils';
import TrInput from '../TrInput/TrInput';
import TrStaticText from '../TrInput/TrStaticText';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
import defaultMixin from '../../mixins/defaultMixin';
import inputMixin from '../../mixins/inputMixin';
export default {
  name: 'tr-text-block-with-input-impr',
  components: { TrInput, TrBox, TrStaticText },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin, inputMixin],
  data() {
    return {
      imageData: [],
      textItem: [],
      staticText: [],
      inputData: [],
      baseItems: _.cloneDeep(this.startGameConfig.items),
      words: [],
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
        wordConfig: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.wordConfig) || {},
        delimiter: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.delimiter) || {},
      },
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  methods: {
    /**
     * parsing function. Replace markers (__elem0__,__elem1__, etc.) to component and passing all data
     * @method parseText
     * @param  {String}  text base text with markers
     * @return {String}       reparsed text with correct components
     */
    parseText(text, itemConfig) {
      text = _.split(text, /__\w*__/g);
      text = text.map(this.katextParser);
      let type;
      if (itemConfig) {
        type =
          itemConfig.markers &&
          itemConfig.markers.map((item) => {
            return item.type ? item.type : false;
          });
      }
      let pText = [];
      if (text.length > 1) {
        _.each(text, (item, index) => {
          let processElement = this.baseItems[index];
          if (index === 0) {
            pText.push(`<div class="text-with-input"
          :style="getStyle(baseItems[${index}])">`);
          }
          if (index <= text.length - 2) {
            let newText = `<tr-input
            :config="baseItems[${index}]"
            :tr-input-value="inputData"
            :tr-input-value-index="${index}"
            :inputWidth="inputWidth(baseItems[${index}])"
            :inputHeight="inputHeight(baseItems[${index}])"
            :inputType="inputType(baseItems[${index}])"
            :input-font-size="setInputFontSize(baseItems[${index}])"
            :input-font-style="setInputFontStyle(baseItems[${index}])"
            @click.native="resetCheckStatus"
            class="input-style"
            :max-length="baseItems[${index}].inputMaxLength||baseItems.inputMaxLength||startGameConfig.inputMaxLength"
          ></tr-input>`;

            // :key="baseItems[${index}].id"
            if (item) {
              pText.push('<div class="text-block-inner-text" :style="getInnerTextStyle(baseItems[0])">');

              pText.push(item);
              pText.push('</div>');
            }
            pText.push(newText);
          } else {
            pText.push(`<div  class="text-block-inner-text" :style="getInnerTextStyle(baseItems[0])">`);
            pText.push(item);
            pText.push('</div>');
          }
        });
        pText.push('</div>');
      } else {
        pText.push(`<div class="text-with-input" >`);
        pText.push('<div class="text-block-inner-text" >');
        pText.push(text[0]);
        pText.push('</div>');
        pText.push('</div>');
      }
      return pText.join('');
    },
    init() {
      this.textItem = this.prepareData();
      let markersArray = [];
      _.each(this.textItem, (item) => {
        if (item.markers) {
          _.each(item.markers, (marker) => {
            markersArray.push(marker);
          });
        } else {
          markersArray.push(item);
        }
      });
      // this.textItem = markersArray;
      this.inputData = _.map(markersArray, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
          caseSensitive: item.caseSensitive || this.caseSensitive,
          coupled: item.coupled,
          mathematica: item.mathematica,
          replace: item.replace,
        };
      });
      this.textItem = _.map(this.textItem, (item) => {
        /**
         * jesli jest <br /> to linia jest lamana. Pierwszy wiersz pobiera wartosc z pos.
         * Kolejne biora pozycje y z wlasciwosc blockHeight mnozona przez ilosc lini
         * @method if
         */
        if (this.searchTag(item.text)) {
          let multiline = _.map(this.splitBytTag(item.text), this.parseText);
          if (!_.isArray(item.markers)) {
            item.markers = _.map([1], () => {
              // cssInnerTextStyle cssStyle
              return _.pick(item, ['correct', 'cssInnerTextStyle', 'cssStyle', 'type']);
            });
          }
          let modifyMarkers = this.processMarkers(item.markers, multiline);
          // item.markers = modifyMarkers;
          let multilineObj = _.map(multiline, (text, index) => {
            /**
             * obliczanie odstepu miedzy liniami na podstawie blockHeight i ilosci lini
             */
            let blockHeight = item.blockHeight || this.startGameConfig.blockHeight || 50;
            if (multiline.length % 2 === 0) {
              if (index === 0) {
                return _.extend(
                  {},
                  item,
                  { hasInput: this.countMatches(text, '<tr-input') > 0 },
                  { markers: modifyMarkers[index], multiline: true },
                  {
                    pos: {
                      x: item.pos.x,
                      y: item.pos.y - blockHeight / 2 + (blockHeight / multiline.length) * index,
                    },
                  },
                  { text: text }
                );
              } else {
                return _.extend(
                  {},
                  item,
                  { hasInput: this.countMatches(text, '<tr-input') > 0 },
                  { markers: modifyMarkers[index], multiline: true },
                  {
                    pos: {
                      x: item.pos.x,
                      y: item.pos.y - blockHeight / 2 + (blockHeight / multiline.length) * index,
                    },
                  },
                  { text: text }
                );
              }
            } else {
              let posY = item.pos.y - blockHeight / 2;
              if (index === 0) {
                return _.extend(
                  {},
                  item,
                  { hasInput: this.countMatches(text, '<tr-input') > 0 },
                  { markers: modifyMarkers[index], multiline: true },
                  { pos: { x: item.pos.x, y: posY } },
                  { text: text }
                );
              } else {
                return _.extend(
                  {},
                  item,
                  { hasInput: this.countMatches(text, '<tr-input') > 0 },
                  { markers: modifyMarkers[index], multiline: true },
                  {
                    pos: {
                      x: item.pos.x,
                      y: posY + (blockHeight / multiline.length) * index,
                    },
                  },
                  { text: text }
                );
              }
            }
          });
          return _.extend({}, _.omit(item, ['text', 'markers']), {
            multiline: true,
            items: multilineObj,
          });
        } else {
          item.text = this.parseText(item.text, item);
          if (!_.isArray(item.markers)) {
            item.markers = _.map([1], () => {
              // cssInnerTextStyle cssStyle
              return _.pick(item, ['correct', 'cssInnerTextStyle', 'cssStyle', 'type']);
            });
          }
          return _.extend({}, _.omit(item, ['text', 'markers']), {
            items: (item = _.map([1], () => {
              return item;
            })),
          });
        }
      });
    },
    processMarkers(markers, multiline) {
      let newMarkersArray = [];
      if (multiline.length > 0) {
        if (markers) {
          let arrayStructure = _.map(multiline, (text) => {
            return this.countMatches(text, '<tr-input');
          });
          let arr = markers;
          newMarkersArray = _.map(arrayStructure, (item) => {
            let mark = _.take(arr, item);
            arr = _.slice(arr, item);
            return mark;
          });
          markers = newMarkersArray;
        }
      }
      return markers;
    },
    countMatches(text, marker) {
      let regExp = new RegExp(marker, 'g');
      return (text.match(regExp) || []).length;
    },
    splitBytTag(text) {
      return _.split(text, /<br \/>/g);
    },
    searchTag(text) {
      return _.includes(text, '<br />');
    },
    isMultiline(obj) {
      return obj.multiline;
    },
    processData(node, staticText, imageArray, parentNode) {
      if (node.items) {
        // if(status.length>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    prepareData() {
      let staticText = [];
      let imageArray = [];
      let pick = this.startGameConfig.pick;
      let data = _.cloneDeep(this.startGameConfig.items);
      let staticIndexArray = _.filter(data, (item) => {
        return !_.isNil(item['staticIndex']);
      });
      if (staticIndexArray.length > 0) {
        pick = this.startGameConfig.pick - staticIndexArray.length;
        data = _.difference(data, staticIndexArray);
      }
      if (this.startGameConfig.items && this.startGameConfig.pick && this.startGameConfig.shuffle) {
        data = _.sampleSize(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && pick) {
        data = _.take(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && this.startGameConfig.shuffle) {
        data = _.shuffle(data);
      }
      _.each(staticIndexArray, (item) => {
        data.push(item);
      });
      data = _.flattenDeep(
        _.map(data, (item) => {
          return this.processData(item, staticText, imageArray, this.startGameConfig);
        })
      );
      /** add image layout */
      this.imageData = imageArray;
      if (this.startGameConfig.mainImage) {
        this.imageData.unshift(this.startGameConfig.mainImage);
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      /** shuffle words in box */
      if (this.startGameConfig.words) {
        this.words = _.shuffle(_.cloneDeep(this.startGameConfig.words));
      }
      /** set staticIndex (fixed position) */
      let sData = {};
      let staticData = _.filter(data, (item) => {
        return !_.isNil(item.staticIndex);
      });
      if (staticData.length > 0) {
        staticData = _.sortBy(_.cloneDeep(staticData), ['staticIndex']);
        data = _.map(data, (item) => {
          if (_.isNil(item.staticIndex)) {
            return item;
          }
        });
      }
      data = _.compact(data);
      sData = _.difference(data, staticData);
      _.each(staticData, (item) => {
        sData.splice(item.staticIndex, 0, item);
      });
      data = sData;
      /** add layout image */
      if (this.startGameConfig.layoutImage && this.startGameConfig.layoutImage.length) {
        let imageList = _.cloneDeep(this.imageData);
        let first;
        if (this.startGameConfig.mainImage) {
          first = _.head(imageList);
          imageList = _.tail(imageList);
        }
        this.imageData = _.map(_.cloneDeep(imageList), (item, index) => {
          return _.defaultsDeep(_.cloneDeep(item), _.cloneDeep(this.startGameConfig.layoutImage[index]));
        });
        if (this.startGameConfig.mainImage) {
          this.imageData.unshift(first);
        }
      }
      /** add static text */
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
        staticText = this.startGameConfig.staticText;
        // staticText = staticText.map((o) => {
        //   o.text = this.katextParser(o.text);
        //   return o;
        // });
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.textItem = _.map(_.cloneDeep(data), (item, index) => {
        return _.defaultsDeep(item, _.cloneDeep(this.startGameConfig.layoutItems[index]));
      });
      /**
       * add words box to game
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.textItem, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.cloneDeep(this.textItem);
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }

      return _.merge(
        {
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center,center',
          position: 'relative',
          display: 'block',
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        },
        this.getCustomStyle(imageData),
        {
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
      );
    },
    setGameStyle() {
      return {
        'flex-direction': this.startGameConfig.flexDirection || 'row',
      };
    },
    getStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getTextStyle(element) {
      let height = element.blockHeight
        ? utils.elementHeight(element.blockHeight)
        : utils.elementHeight(this.startGameConfig.blockHeight);
      // if (element.multiline) {
      //   height = element.textBlockHeight
      //     ? utils.elementHeight(element.textBlockHeight)
      //     : utils.elementHeight(this.startGameConfig.textBlockHeight);
      // }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(element), {
        top: utils.elementTopPosition(element.pos.y, element.offsetVertical),
        left: utils.elementLeftPosition(element.pos.x, element.offsetHorizontal),
        width: element.blockWidth
          ? utils.elementWidth(element.blockWidth)
          : utils.elementWidth(this.startGameConfig.blockWidth),
        height: height,
        'background-color': element.blockBackgroundColor || this.startGameConfig.blockBackgroundColor,
        'font-size': this.startGameConfig.gameFontSize + 'px',
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },

    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
    },
    checkGameAction() {
      return this.inputOnBackgroundCheckGameAction();
    },

    prepareInputData(inputData, textItems) {
      let arr = _.cloneDeep(inputData);
      let newMarkersArray = [];
      if (textItems.items.length > 0) {
        let arrayStructure = _.map(textItems.items, (item) => {
          return this.countMatches(item.text, '<tr-input');
        });

        newMarkersArray = _.map(arrayStructure, (item) => {
          let mark = _.take(arr, item);
          arr = _.slice(arr, item);
          return mark;
        });
      }
      return newMarkersArray;
    },
    getCorrectInput(mainIndex, index) {
      let counter = 0;
      let elem = {};
      if (this.textItem[mainIndex].items[index].markers.length > 0) {
        for (var i = 0; i <= mainIndex; i++) {
          if (i < mainIndex) {
            for (var j = 0; j < this.textItem[i].items.length; j++) {
              _.each(this.textItem[i].items[j].markers, () => {
                counter++;
              });
            }
          } else {
            for (var j = 0; j <= index; j++) {
              elem = _.extend(
                {},
                {
                  startIndex: counter,
                  number: this.textItem[i].items[j].markers.length,
                }
              );
              _.each(this.textItem[i].items[j].markers, () => {
                counter++;
              });
            }
          }
        }
        return _.slice(this.inputData, elem.startIndex, elem.startIndex + elem.number);
      }
      return [];
    },
    getCorrectBaseItems(mainIndex, index) {
      let markersArray = [];
      if (_.has(this.textItem[mainIndex], `items[${index}].markers`)) {
        _.each(this.textItem[mainIndex].items[index].markers, (marker) => {
          markersArray.push(_.extend(marker, _.omit(this.textItem[mainIndex].items[index], ['markers', 'pos'])));
        });
      } else {
        markersArray.push(_.omit(this.textItem[mainIndex].items[index], ['pos']));
      }
      return markersArray;
    },
    dynComponent(mainIndex, index) {
      let correctInput = this.getCorrectInput(mainIndex, index);

      const template = this.content ? this.content : this.textItem[mainIndex].items[index].text;
      let data = {
        mainImage: _.cloneDeep(this.startGameConfig.mainImage),
        text: _.cloneDeep(this.textItem[mainIndex].items[index].text),
        inputData: correctInput,
        baseItems: _.cloneDeep(this.getCorrectBaseItems(mainIndex, index)),
      };
      return {
        template,
        mixins: [defaultMixin],
        components: { TrInput },
        data() {
          return data;
        },
        methods: {
          selectConfig(item) {
            return _.omit(item, ['pos', 'width', 'height']);
          },
          getStyle(item) {
            return _.merge({}, this.getCustomStyle(item), {
              width: item.textBlockWidth
                ? utils.elementWidth(item.textBlockWidth)
                : utils.elementWidth(this.startGameConfig.textBlockWidth),
              height: item.textBlockHeight
                ? utils.elementHeight(item.textBlockHeight)
                : utils.elementHeight(this.startGameConfig.textBlockHeight),
              // 'justify-content': ( item.flexJustify ) ? 'center' : item.flexJustify,
            });
          },
          getInnerTextStyle(item) {
            return _.assign({}, this.getCustomInnerTextStyle(item));
          },
          getCustomInnerTextStyle(item) {
            let customStyle = {};
            if (item.cssInnerTextStyle) {
              if (_.isObject(item.cssInnerTextStyle)) {
                customStyle = _.mapKeys(item.cssInnerTextStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
            // return {
            //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.startGameConfig.textBlockWidth),
            //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.startGameConfig.textBlockHeight),
            //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
            // };
          },
          getIndexStyle(item) {
            return _.merge({}, this.getCustomStyle(item));
          },
          getCustomStyle(item) {
            let customStyle = {};
            if (item.cssStyle) {
              if (_.isObject(item.cssStyle)) {
                customStyle = _.mapKeys(item.cssStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
            // return {
            //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.startGameConfig.textBlockWidth),
            //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.startGameConfig.textBlockHeight),
            //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
            // };
          },
          inputWidth(item) {
            if (item.inputWidth) {
              return item.inputWidth;
            } else if (this.startGameConfig.inputWidth) {
              return this.startGameConfig.inputWidth;
            }
            return false;
          },
          inputHeight(item) {
            if (item.inputHeight) {
              return item.inputHeight;
            } else if (this.startGameConfig.inputHeight) {
              return this.startGameConfig.inputHeight;
            }
            return false;
          },
          inputType(item) {
            if (item.type) {
              return item.type;
            }
            return 'normal';
          },
          setNewValue(value, index) {
            let trValue = _.defaults({}, value, {
              correct: undefined,
              val: '',
              block: false,
              inputStatus: null,
              coupled: false,
              mathematica: false,
              replace: item.false,
              caseSensitive: false,
            });
            trValue.val = value.text;
            _.assign(this.inputData[index], trValue, { val: value });
          },
          setInputFontSize(item) {
            return item.inputFontSize || this.startGameConfig.inputFontSize;
          },
          setInputFontStyle(item) {
            return item.inputFontStyle || this.startGameConfig.inputFontStyle;
          },
        },
        // computed:{
        //   inputData(){
        //     if(this.inputData[ index ].markers)
        //     return this.inputData[ index ],
        //   },
        // }
        props: this.$props,
      };
    },
    setInputFontStyle(item) {
      return item.inputFontStyle || this.startGameConfig.inputFontStyle;
    },
    setInputFontSize(item) {
      return item.inputFontSize || startGameConfig.inputFontSize;
    },
  },
  computed: {
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
    caseSensitive() {
      return this.startGameConfig.caseSensitive;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-text-block-with-input-impr {
  height: 100%;
  width: 100%;
  margin-left: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  .text-container {
    text-align: justify;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.text-with-input {
  display: flex;
  width: 250px;
  justify-content: space-between;
  align-items: baseline;
  flex-direction: row;
}
.text-block-inner-text {
  white-space: pre;
  // margin-right: 1em;
  // margin-left: 1em;
}
.marker-style {
  width: 100px;
  height: 40px;
  display: inline-block;
}
</style>
<style lang="scss">
.game-tr-text-block-with-input-impr {
  .text-container-multiline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    .text-container {
      // height: 100%;
      // width: 100%;
      // position: relative;
      .text-with-input {
        .text-block-inner-text {
          white-space: pre;
          // margin-right: 1rem;
          // margin-left: 1rem;
        }
      }
    }
  }
}
</style>
